import { enumToArray } from '../utils/enum-to-array';

/** Special matrix type. */
export enum SpecialMatrixType {

	/** Definitions type. */
	Definitions = 'DEFINITIONS',

	/** Due diligence type. */
	DueDiligence = 'DUE_DILIGENCE',

	/** Reporting mechanics type. */
	ReportingMechanics = 'REPORTING_MECHANICS',
}

export namespace SpecialMatrixType {

	const TITLE_MAP: Record<SpecialMatrixType, string> = {
		[SpecialMatrixType.Definitions]: 'Definitions',
		[SpecialMatrixType.DueDiligence]: 'Due Diligence',
		[SpecialMatrixType.ReportingMechanics]: 'Reporting Mechanics',
	};

	/**
	 * Convert a certain enum value to readable title.
	 * @param value Value of enum.
	 */
	export function toReadable(value: SpecialMatrixType): string {
		const readable = TITLE_MAP[value];
		if (readable == null) {
			console.warn(`Unknown type: ${value}`);
		}
		return readable;
	}

	/**
	 * Get list of all enum items.
	 */
	export function toArray(): SpecialMatrixType[] {
		return enumToArray(SpecialMatrixType);
	}
}
